<template>
  <div id="management-queue">
    <div class="table-section">
      <el-card class="box-card" shadow="never">
        <el-form
          :inline="true"
          :model="searchParams"
          class="form-inline"
          
        >
          <el-form-item label="队列代码">
            <el-input v-model.trim="searchParams.code" placeholder="队列代码" />
          </el-form-item>
          <el-form-item label="队列名称">
            <el-input v-model.trim="searchParams.name" placeholder="队列名称" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="search">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button @click="clear">清空</el-button>
            <el-button v-if="false" @click="jump">跳</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>

    <div class="table-section">
      <el-table
        :data="manageQueueList"
        :header-row-style="headerRowStyle"
        border
        highlight-current-row
        max-height="550px"
      >
        <el-table-column prop="customgroupid" label="渠道id" />
        <el-table-column prop="code" label="队列代码" />
        <el-table-column prop="name" label="队列名称">
          <template slot-scope="scope">
            <router-link
              :to="{
                name: 'manage-queue-tasks',
                params: { queueId: scope.row.id },
              }"
              >{{ scope.row.name }}</router-link
            >
          </template>
        </el-table-column>
        <el-table-column prop="taskCount" label="计划案件数" />
        <el-table-column prop="agentCount" label="用户数" />
      </el-table>
    </div>

    <div class="pagination-section">
      <el-pagination
        :page-size="pageSize"
        :total="manageQueueListTotalCount"
        layout="total, prev, pager, next"
        @current-change="changePage"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "management-queue",
  data() {
    return {
      headerRowStyle: {
        "background-color": "#6584b4",
      },
      searchParams: {},
      pageSize: 20,
      page: 0,
    };
  },
  computed: {
    ...mapGetters([
      "currentUser",
      "manageQueueList",
      "manageQueueListTotalCount",
    ]),
    type() {
      return this.$route.query.type;
    },
  },
  created() {
    this.loadQueues();
  },
  methods: {
    ...mapActions(["fetchManageQueue"]),
    loadQueues() {
      this.searchParams.userId = this.currentUser.id;
      return this.fetchManageQueue({
        searchParams: this.searchParams,
        page: this.page,
        size: this.pageSize,
        queueType: this.type,
      });
    },
    changePage(currentPage) {
      this.page = currentPage;
      this.loadQueues();
    },
    search() {
      this.page = 1;
      this.loadQueues();
    },
    clear() {
      this.searchParams = {};
      this.search();
    },
    // jump () {
    //   this.$router.push({ name: 'manage-queue-tasks', params: { queueId: 2 } })
    // }
  },
};
</script>
